import Vue from 'vue';
window.Vue = Vue;
export const scrollTo = {
	bind(el, binding, vnode) {

		let selector = binding.value;

		function goto(e){
			e.preventDefault();
			var element = document.querySelector(selector);
			var main = document.querySelector('main');
			main.style.height = 'auto';
			var top = element.offsetTop - 50;
			main.scrollTo(0, top);
		}

		el.addEventListener('click', goto, true);
	}
};



// WEBPACK FOOTER //
// ./src/directives/scroll-to.js